import axiosApi from "../../components/Api/Axios";
import BackendServices from "../../components/Api/BackendService";
import RecallStatusView from "../../Models/Recall/RecallStatusView";

export default () =>
  axiosApi.get<RecallStatusView[]>(
    `${BackendServices.RECALL_SERVICE.RECALL}/Statuses`
  );
